import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../app/hooks';
import Spinner from '../../components/common/Spinner';
import { copyLink } from '../../helpers/helperFunctions';
import { Button } from '../../styles/GlobalComponents';
import { color } from '../../styles/GlobalStyles';
import { Icon, IconCopy } from '../../styles/Icons';
import { FlexCenter, SelectedAddress } from '../../styles/stylesStyled';
import { QrCodeWrapper, SubTitle, Title } from './SettingsStyled';

export const QRSetup = ({
  setStep
}: {
  setStep: Dispatch<SetStateAction<number>>;
}) => {
  const { t } = useTranslation('settings');
  const { user2FAData, loadingVerification } = useAppSelector(
    (state) => state.settings
  );
  return (
    <>
      {loadingVerification ? (
        <Spinner />
      ) : (
        <FlexCenter style={{ flexDirection: 'column' }}>
          <>
            <Title>{t('security.scan_code')} </Title>
            {user2FAData !== null && (
              <QrCodeWrapper>
                <div
                  style={{
                    width: 192,
                    height: 192,
                    backgroundImage: `url(${user2FAData.qrUrl})`,
                    backgroundRepeat: 'no-repeat'
                  }}></div>
              </QrCodeWrapper>
            )}
            <SelectedAddress
              onClick={() => {
                copyLink(
                  user2FAData?.secret || '',
                  t('security.success_copied')
                );
              }}
              style={{ cursor: 'pointer' }}>
              <div className='truncated'>
                <div>{user2FAData?.secret}</div>
              </div>
              <Icon ml='10' color={color.colors.neutral900}>
                <IconCopy />
              </Icon>
            </SelectedAddress>
            <SubTitle style={{ textAlign: 'center' }}>
              {t('security.code_information')}
            </SubTitle>
            <Button
              maxWidth='300px'
              h='50px'
              m={'30px 0 0 0'}
              opacity={'true'}
              onClick={() => setStep(2)}>
              {t('security.next')}
            </Button>
          </>
        </FlexCenter>
      )}
    </>
  );
};
